export enum DeviceVerificationStepperEnum {
  One = 1,
  Two
}
